import { InjectionToken } from '@angular/core';
import { TrackJS, TrackJSConfigureOptions } from 'trackjs';

export interface TrackjsClient {
  isInstalled(): boolean;
  configure(options: TrackJSConfigureOptions): boolean;
  addMetadata(key: string, value: string): void;
  removeMetadata(key: string): void;
  track(error: object | string | Error): void;
}

export const TRACKJS_CLIENT = new InjectionToken<TrackjsClient>('TRACKJS_CLIENT', {
  providedIn: 'root',
  factory: (): TrackjsClient => TrackJS,
});
